module.exports = __webpack_public_path__ + "public/images/slider/speaker-9.0afbe6eba26d99bd65b697a2de58111f.jpg";